/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Cta_StartInputs */

const en_tut_cta_start = /** @type {(inputs: Tut_Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start the tutorial`)
};

const id_tut_cta_start = /** @type {(inputs: Tut_Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai tutorialnya`)
};

/**
* | output |
* | --- |
* | "Start the tutorial" |
*
* @param {Tut_Cta_StartInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_cta_start = /** @type {((inputs?: Tut_Cta_StartInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Cta_StartInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_cta_start(inputs)
	return en_tut_cta_start(inputs)
});